import React, { PropTypes } from 'react'
import { Link } from 'react-router'

import MobileNavBar from 'components/MobileNavBar'
import MobileNavBarBackButton from 'components/MobileNavBarBackButton'
import * as paths from 'utils/paths'

const ProfileMobileNavBar = ({ isLoggedIn, children, back }) => {
  const url = isLoggedIn ? paths.currentUserProfile() : '/'
  const leftControl = back ? <MobileNavBarBackButton /> : null
  return (
    <MobileNavBar
      leftControl={leftControl}
      rightControl={
        <Link className='btn btn-default' to={url}>
          {isLoggedIn ? 'Mi perfil' : 'Inicio'}
        </Link>
      }>
      {children}
    </MobileNavBar>
  )
}

ProfileMobileNavBar.propTypes = {
  isLoggedIn: PropTypes.bool,
  children: PropTypes.string,
  back: PropTypes.bool
}

ProfileMobileNavBar.defaultProps = {
  isLoggedIn: false,
  back: false,
  children: 'Configurar servicio'
}

export default ProfileMobileNavBar



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ProfileMobileNavBar/ProfileMobileNavBar.js